/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../../app/base/base.service.ts" />

module Eseebase {
    export class TextService {
        private texts: TranslationPair[];
        constructor(private baseService: BaseService, private $q: ng.IQService, private organizationSettingsService: OrganizationSettingsService) {
        }

        public translate(key: string) {
            if (this.texts == null) {
                return key;
            }
            else {
                if (this.organizationSettingsService.uiStyling != null)
                {
                    if (key == "ModelFilter_Association" && this.organizationSettingsService.uiStyling.textServiceOverruleModelFilter_Association()) {
                        key = "GermanPublicHousing_Association";
                    }
                    else if (key == "ModelFilter_Department" && this.organizationSettingsService.uiStyling.textServiceOverruleModelFilter_Department()) {
                        key = "GermanPublicHousing_Department";
                    }
                    else if (key == "ModelFilter_Localizer" && this.organizationSettingsService.uiStyling.textServiceOverruleModelFilter_Localizer()) {
                        key = "GermanPublicHousing_Localizer";
                    }
                }
                var item = this.texts.filter(t => t.key == key);
                if (item != null && item.length > 0) {
                    if (item[0].value.length <= 0) {
                        return ">" + key + "<";
                    }
                    return item[0].value;
                }
                else {
                    return ">>" + key + "<<";
                }
            }
        }

        public reset() {
            this.texts = null;
        }

        public downloadTexts() {
            var vm = this;
            var d = this.$q.defer();
            if (this.texts != null) {
                d.resolve(this.texts);
            }
            else {
                this.baseService.get('localization/get').then((data) => {
                    if (data != null && data.data != null) {
                        vm.texts = <TranslationPair[]>data.data;
                        d.resolve(vm.texts);
                    }
                    else {
                        d.reject(400);
                    }
                },
                (reason) => {
                    d.reject(reason);
                });
            }
            return d.promise;
        }
    }

    TextService.$inject = ['BaseService', '$q', 'OrganizationSettingsService'];
    angular
        .module('eseebase')
        .service('TextService', TextService);
}